<template>
  <PageWrapper
    :isLoading="isLoading"
    isExtended
    hasFilters
    @submitFilters="getAllMasterIncomeFromGroupClasses"
  >
    <template #title> لیست درآمد کلاس های گروهی شما </template>

    <template #filters>
      <RangeDatePicker
        class="w-24 filters-width"
        label="بازه‌ی تاریخ کلاس گروهی را وارد کنید"
        @getDateRange="setDateRange"
      ></RangeDatePicker>
    </template>

    <template #extend>
      <div>
        <p>
          مجموع درآمد استاد:
          <span class="text-primary">
            {{ Intl.NumberFormat("en-US").format(masterSumIncome) }}
          </span>
          تومان
        </p>
        <p>
          تعداد کلاس های تدریس شده:
          <span class="text-primary">
            {{ Intl.NumberFormat("en-US").format(totalCount) }}
          </span>
          کلاس
        </p>
      </div>
    </template>
    <CustomTable
      :pageNumber="masterGroupClassIncomeFilters.pageNumber"
      :count="masterGroupClassIncomeFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="masterGroupClassIncomeList"
      @changePage="changePage"
    ></CustomTable>
  </PageWrapper>
</template>
<script>
export default {
  props: {
    masterUserIdFilter: {
      type: [String, Number],
      default: null,
    },
  },
  watch: {
    masterUserIdFilter: {
      handler(val) {
        this.masterGroupClassIncomeFilters.masterUserId =
          this.masterUserIdFilter;
      },
      immediate: true,
    },
  },
  mounted() {
    this.getAllMasterIncomeFromGroupClasses();
  },
  data() {
    return {
      isLoading: false,
      masterGroupClassIncomeList: null,
      totalCount: null,
      masterSumIncome: null,
      masterGroupClassIncomeFilters: {
        pageNumber: 1,
        count: 10,
        groupClassMasterId: null,
        masterUserId: null,
        from: null,
        to: null,
      },
      tableColumns: [
        {
          key: "masterUserPaymentId",
          label: "شناسه",
        },
        {
          key: "studentsCount",
          label: "تعداد شرکت کننده ها",
          formatter: (val) => (val ? `${val} نفر` : "-"),
        },
        {
          key: "createDate",
          label: "تاریخ ثبت واریز",
          formatter: (val) => (val ? this.customFullDateTimeConvert(val) : "-"),
        },
        {
          key: "basePrice",
          label: "قیمت پایه هر کاربر",
          formatter: (val) =>
            val ? `${Intl.NumberFormat("en-US").format(val)} تومان` : "-",
        },
        {
          key: "sumSessionPrice",
          label: "میزان درآمد",
          formatter: (val) =>
            val ? `${Intl.NumberFormat("en-US").format(val)} تومان` : "-",
        },
      ],
    };
  },
  methods: {
    setDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.masterGroupClassIncomeFilters.from = new Date(
          dateRange[0]
        ).toISOString();
        this.masterGroupClassIncomeFilters.to = new Date(
          dateRange[1]
        ).toISOString();
      } else {
        this.masterGroupClassIncomeFilters.from = null;
        this.masterGroupClassIncomeFilters.to = null;
      }
    },
    changePage(pageNumber) {
      this.masterGroupClassIncomeFilters.pageNumber = pageNumber;
      this.getAllMasterIncomeFromGroupClasses();
    },
    async getAllMasterIncomeFromGroupClasses() {
      try {
        this.isLoading = true;
        const _this = this;
        const getMasterIncomeFromGroupClasses =
          new GetMasterIncomeFromGroupClasses(_this);
        getMasterIncomeFromGroupClasses.setRequestParamDataObj(
          _this.masterGroupClassIncomeFilters
        );
        await getMasterIncomeFromGroupClasses.fetch((res) => {
          _this.masterGroupClassIncomeList = res.data.data;
          _this.masterSumIncome = res.data.sum;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  mixins: [timeConvertUtils],
  components: {
    PageWrapper,
    CustomTable,
    RangeDatePicker,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { GetMasterIncomeFromGroupClasses } from "@/libs/Api/GroupClass";
</script>
